'use strict';

define('lib/helpers/disclaimer',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('disclaimer', function (opt) {
    var data = ['data-disclaimer="' + opt.hash.code + '"'];
    if (opt.hash.fallback) {
      data.push('data-fallback="' + opt.hash.fallback + '"');
    }
    return new Handlebars.SafeString('<sup class="color-red footnote"><a class="js-disclaimer-lookup" href="#" ' + data.join(' ') + '></a></sup>');
  });
});

